import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  Icon,
  IconVariant,
  JustifyContent,
  Strong,
} from '@gousto-internal/citrus-react'

export const FreeDeliveryPillNDD = () => (
  <Box
    data-testid="free-delivery-pill-ndd"
    bg={Color.Success_50}
    width={['311px', '272px']}
    height="36px"
    display={Display.Flex}
    justifyContent={JustifyContent.Center}
    alignItems={AlignItems.Center}
    gap={2}
    style={{ borderRadius: '4px' }}
  >
    <Icon name="local_shipping" size={6} variant={IconVariant.Default} />
    <Body2 size={2}>
      <Strong>Free delivery</Strong> on your first box!
    </Body2>
  </Box>
)
